import { timeAgo } from '@/shared/utils/timeAgo';
import type { ActivityFeedItem } from '@yawi/types';

interface ActivityFeedProps {
  items: ActivityFeedItem[];
  loading?: boolean;
}

const TYPE_COLOR: Record<ActivityFeedItem['type'], string> = {
  access: '#5B9BD5',
  visit: '#6FBF73',
  incident: '#EF9F27',
  maintenance: '#7F77DD',
};

export function ActivityFeed({ items, loading }: ActivityFeedProps) {
  return (
    <div className="bg-white dark:bg-surface-secondary rounded-xl border-[0.5px] border-[#E8E6F8] dark:border-theme-light p-4 flex flex-col">
      <h4 className="text-[15px] font-semibold text-[#1A1A18] dark:text-theme mb-3">Actividad reciente</h4>

      <div className="space-y-1 flex-1">
        {loading ? (
          Array.from({ length: 4 }).map((_, i) => (
            <div key={i} className="flex items-center gap-2.5 p-2">
              <div className="w-8 h-8 rounded-full bg-theme-200/60 animate-pulse flex-shrink-0" />
              <div className="flex-1 space-y-1.5 animate-pulse">
                <div className="h-3 w-2/3 rounded bg-theme-200/60" />
                <div className="h-2.5 w-1/2 rounded bg-theme-200/40" />
              </div>
            </div>
          ))
        ) : items.length === 0 ? (
          <div className="flex-1 flex items-center justify-center py-6">
            <p className="text-[13px] text-[#888780] dark:text-theme-tertiary">Sin actividad reciente</p>
          </div>
        ) : (
          items.map((item) => (
            <div key={item.id} className="flex items-center gap-2.5 p-2 rounded-lg hover:bg-[#F8F7FF] dark:hover:bg-theme transition-colors">
              <div
                className="w-8 h-8 rounded-full flex items-center justify-center text-white text-[11px] font-medium flex-shrink-0"
                style={{ backgroundColor: TYPE_COLOR[item.type] }}
              >
                {item.initials}
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-[13px] font-semibold text-[#1A1A18] dark:text-theme truncate leading-tight">{item.title}</p>
                <p className="text-[11px] text-[#888780] dark:text-theme-tertiary truncate leading-tight">{item.subtitle}</p>
              </div>
              <span className="text-[11px] text-[#888780] dark:text-theme-tertiary flex-shrink-0 whitespace-nowrap">
                {timeAgo(item.timestamp)}
              </span>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
